import React, { useState } from 'react'
import { Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCol, CustomSelect, FormLabels } from 'src/components'
import { filteredOptions, getProjectOptionName } from 'src/core/helpers'
import {
  projectOptionListSelector,
  projectFormStateSelector,
  setProjectFormItemValue,
} from 'src/features'
import { validateProjectOption } from 'src/features/project-options/api'
import ProjectFormRegistryValidationErrorModal from '../../ProjectFormError/ProjectFormRegistryValidationError/ProjectFormRegistryValidationError'

const ProjectFormRegistryName: React.FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { is_active, kind } = useAppSelector(projectFormStateSelector)
  const { data: projectOptions } = useAppSelector(projectOptionListSelector)
  const options = filteredOptions(projectOptions, 'registry_depositing_name')
  const [showRegistryValidationErrorModal, setShowRegistryValidationErrorModal] = useState(false)
  const [registryName, setRegistryName] = useState<string | null>(null)

  const handleChange = async (value: string) => {
    const [optionId, optionValue, optionValueTranslated] = value.split('::')

    const isValid = await validateProjectOption(Number(optionId))
    if (isValid) {
      dispatch(setProjectFormItemValue({ key: 'registry_depositing_name', value: optionValueTranslated }))
    } else {
      dispatch(setProjectFormItemValue({ key: 'registry_depositing_name', value: null }))
      setRegistryName(optionValue)
      setShowRegistryValidationErrorModal(true)
    }
  }

  return <>
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Projects.Form.NameOfRegistry')}
          subtitle={t('Projects.Form.RegistryLabel')}
        />
      </CustomCol>
      <CustomCol>
        <CustomSelect
          name='registry_depositing_name'
          placeholder={t('Projects.Form.RegistryPlaceholder')}
          onChange={handleChange}
          required={kind === 'carbon_forward' ? false : is_active}
        >
          {options.map(po => (
            <Select.Option
              key={po.id}
              value={`${po.id}::${getProjectOptionName(po, true)}::${getProjectOptionName(po)}`} // Concatenate id and value
            >
              {getProjectOptionName(po)}
            </Select.Option>
          ))}
        </CustomSelect>
      </CustomCol>
    </Row>
    <ProjectFormRegistryValidationErrorModal
      isModalVisible={showRegistryValidationErrorModal}
      handleCancel={() => {
        setShowRegistryValidationErrorModal(false)
        setRegistryName
      }}
      registryName={registryName}
    />
  </>
  
}

export default ProjectFormRegistryName
